// extracted by mini-css-extract-plugin
export var scrollArea = "_pi-0";